const s = {
  name: "FalklandIslands",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12,2c-5,0-9,4-9,9v13H1V11C1,4.9,5.9,0,12,0c6.1,0,11,4.9,11,11v13h-2V11C21,6,17,2,12,2z"/>
		<path class="st0" d="M10,10c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S10,9.4,10,10z"/>
		<path class="st0" d="M16,10c0-0.6-0.4-1-1-1s-1,0.4-1,1s0.4,1,1,1S16,10.6,16,10z"/>
		<path class="st0" d="M15.3,15c2.6-0.2,4.7-2.3,4.7-5c0-2.8-2.2-5-5-5c-1.1,0-2.2,0.4-3,1c-0.8-0.6-1.9-1-3-1c-2.8,0-5,2.2-5,5
			c0,2.7,2.1,4.8,4.7,5l3.3,2.2L15.3,15z M15.4,13L12,9.6L8.6,13C7.1,12.8,6,11.5,6,10c0-1.7,1.3-3,3-3c0.9,0,1.7,0.4,2.2,1L12,8.9
			L12.8,8c0.5-0.6,1.4-1,2.2-1c1.7,0,3,1.3,3,3C18,11.5,16.9,12.8,15.4,13z M10.6,13.8l1.4-1.4l1.4,1.4l-1.4,1L10.6,13.8z"/>
		<path class="st0" d="M8,24c0-2.2,1.8-4,4.1-4c2.2,0,4,1.8,4,4h2c0-3.3-2.7-6-6-6C8.7,18,6,20.7,6,24H8z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as FalklandIslands
};
